module.exports = __webpack_public_path__ + "static/media/GOOGLE_POLISH_FEMALE.a057bc27.mp3";